<template>
	<main class="school-mgn-list" style="background: #f5f5fb;">
		<!-- <div class="mainList">
			<el-form
				ref="aidsForm"
				:model="params"
				label-width="80px"
				:inline="true"
				@submit.native.prevent
				style="margin-left: 13px;padding: 5px 0"
			>
				<el-form-item prop="a">
					<el-input style="width: 220px;" placeholder="教具ID" v-model="params.a" size="small">
						<i slot="prefix" class="el-input__icon el-icon-search"></i>
					</el-input>
				</el-form-item>
				<el-form-item prop="b">
					<el-input style="width: 220px;" placeholder="学生姓名" v-model="params.b" size="small">
						<i slot="prefix" class="el-input__icon el-icon-search"></i>
					</el-input>
				</el-form-item>
				<el-form-item prop="c">
					<el-select
						ref="SearchGrade"
						v-model="params.c"
						style="width: 100px;"
						placeholder="年级"
						size="small"
						@change="checkoutGrade"
						v-if="
							$store.state.user.userInfo.type === $api.account.types.PLATFORM_ADMIN.value ||
							$store.state.user.userInfo.type === $api.account.types.OTHER.value
						"
					>
						<el-option v-for="d in gradesArr" :key="d.val" :label="d.name" :value="d.val" />
					</el-select>

					<el-select
						ref="SearchGrade"
						v-model="params.c"
						style="width: 100px;"
						placeholder="年级"
						size="small"
						@change="checkoutGrade"
						v-else
					>
						<el-option v-for="d in teacherGradesArr" :key="d.val" :label="d.name" :value="d.val" />
					</el-select>
				</el-form-item>
				<el-form-item prop="d">
					<el-select
						ref="SearchClass"
						style="width: 100px;"
						v-model="params.d"
						placeholder="班级"
						size="small"
						@change="checkoutClass"
					>
						<el-option v-for="item in classNumber" :key="item" :label="item" :value="item"></el-option>
					</el-select>
				</el-form-item>
			</el-form>

			<div style="display: flex; margin-left: auto;">
				<template>
					<el-button
						type="primary"
						class="action-btn"
						size="small"
						style="margin-right: 15px; width: 70px;"
						@click=";(currentPage = 1), refreshDataList()"
						>搜索</el-button
					>
					<el-button
						type="primary"
						size="small"
						style="
							background: #f7f8fa;
							border: 1px solid #dcdcdc;
							color: #4b4b4b !important;
							margin-right: 12px;
							width: 70px;
						"
						@click="reset()"
						>重置</el-button
					>
				</template>
			</div>
		</div> -->
		<div _bg="white">
			<div _bg="white" _text="18px border [#3E3E3E]" _p="x-15px y-25px">教具管理</div>
			<section class="list-area" _m="5px">
				<el-table
					:data="dataList"
					tooltip-effect="dark"
					:header-cell-style="{ background: '#FAFAFA', color: '#000000', height: '10px !important' }"
					width="100%"
				>
					<!-- <el-table-column align="center" label="教具编号" prop="id" /> -->
					<el-table-column align="center" label="教具编号" prop="number_in_class" />
					<el-table-column align="center" label="教具ID" prop="device_sn" />
					<el-table-column align="center" label="班内序号" prop="number_in_class" />
					<el-table-column align="center" label="操作">
						<template slot-scope="{ row }">
							<div _flex="~ justify-center">
								<div _text="[#f13048]" _m="r-5px" _flex="~ justify-center" @click="deleteRow(row)">
									<el-tooltip content="解绑" placement="bottom" effect="light">
										<div
											_bg="[#FAFBFF]"
											_w="28px"
											_h="28px"
											_border="rounded-[100px]"
											_flex="~ justify-center items-center"
										>
											<i
												aria-hidden="true"
												class="el-icon-link"
												_cursor="pointer"
												:style="{
													cursor: row.device_sn ? 'pointer' : 'no-drop'
												}"
											></i>
										</div>
									</el-tooltip>
								</div>
								<div _text="[#3F6AF7]" _flex="~ justify-center" @click="editRow(row)">
									<el-tooltip content="编辑" placement="bottom" effect="light">
										<div
											_bg="[#FAFBFF]"
											_w="28px"
											_h="28px"
											_border="rounded-[100px]"
											_flex="~ justify-center items-center"
										>
											<i aria-hidden="true" class="el-icon-edit-outline" _cursor="pointer"></i>
										</div>
									</el-tooltip>
								</div>
							</div>
						</template>
					</el-table-column>
				</el-table>
				<div class="pagination-page">
					<span class="pagetotal">总计：{{ totalItems }}条/{{ Math.ceil(totalItems / pageSize) }}页</span>
					<el-pagination
						class="pagination"
						background
						@size-change="handleSizeChange"
						@current-change="handleCurrentChange"
						:page-size="pageSize"
						:total="totalItems"
						:current-page.sync="currentPage"
						:page-sizes="[10, 20, 50, 100]"
						layout="prev,pager,next,jumper,sizes"
						style="margin-top: 21px; margin-left: 10px;"
					>
					</el-pagination>
				</div>
			</section>
		</div>
	</main>
</template>
<script>
const primarySchool = [
	{ val: 1, name: '一年级' },
	{ val: 2, name: '二年级' },
	{ val: 3, name: '三年级' },
	{ val: 4, name: '四年级' },
	{ val: 5, name: '五年级' },
	{ val: 6, name: '六年级' }
]
const middleSchool = [
	{ val: 7, name: '初一' },
	{ val: 8, name: '初二' },
	{ val: 9, name: '初三' }
]
const highSchool = [
	{ val: 10, name: '高一' },
	{ val: 11, name: '高二' },
	{ val: 12, name: '高三' }
]
const gradesArr = [
	{ val: 1, name: '一年级' },
	{ val: 2, name: '二年级' },
	{ val: 3, name: '三年级' },
	{ val: 4, name: '四年级' },
	{ val: 5, name: '五年级' },
	{ val: 6, name: '六年级' },
	{ val: 7, name: '初一' },
	{ val: 8, name: '初二' },
	{ val: 9, name: '初三' },
	{ val: 10, name: '高一' },
	{ val: 11, name: '高二' },
	{ val: 12, name: '高三' }
]
export default {
	props: [],
	data() {
		return {
			classNumber: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25],
			params: {
				a: '',
				b: '',
				c: '',
				d: ''
			},
			schoolId: '',
			dataList: [],
			pageSize: 10,
			totalItems: 0,
			currentPage: 1, // 第几页
			multipleSelection: [], // 批量删除
			gradesArr,
			primarySchool,
			middleSchool,
			highSchool
		}
	},
	components: {},
	async created() {
		this.getDevicesList()
		const userInfo = this.$store.state.user.userInfo
		if (userInfo.teachers?.length >= 1) {
			const teacherInfo = this.$store.state.user.userInfo?.teachers[0]
			this.schoolId = teacherInfo.school_id
			this.teacherGradesArr = [
				...(teacherInfo.school.primary_school ? primarySchool : []),
				...(teacherInfo.school.middle_school ? middleSchool : []),
				...(teacherInfo.school.high_school ? highSchool : [])
			]
		}
		if (userInfo?.school_admin?.length >= 1) {
			const schoolInfo = userInfo?.school_admin[0]
			this.schoolId = schoolInfo.school_id
			this.teacherGradesArr = [
				...(schoolInfo.school.primary_school ? primarySchool : []),
				...(schoolInfo.school.middle_school ? middleSchool : []),
				...(schoolInfo.school.high_school ? highSchool : [])
			]
		}
	},

	methods: {
		async getDevicesList() {
			const { data, meta } = await this.$api.user.httpGet(`classroom-devices`, {
				page: this.currentPage,
				page_size: this.pageSize
			})
			this.dataList = data
			this.currentPage = meta.current_page
			this.totalItems = meta.total
			console.log(data)
		},
		// 删除~解绑不是删除是更新
		deleteRow(row) {
			if (row.device_sn == '') return
			this.$confirm('是否解绑该教具?', '温馨提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(async () => {
				// await this.$api.resource.deleteDevices(row.id)
				// await this.$api.resource.updatedevices(row.id, {
				// 	// device_sn: row.device_sn,
				// 	device_sn: '',
				// 	number_in_class: row.number_in_class
				// })

        await this.$api.user.httpPut(`edu/classroom-devices/${row.id}/unbind`, {
				})

				this.currentPage = 1
				this.getDevicesList()
				this.$message({
					type: 'success',
					message: '解绑成功!'
				})
			})
		},
		editRow(row) {
			let html = `<div style='color:#D83939'>提示：教具编号是唯一的</div>`
			this.$prompt(`${html}`, '更换教具编号', {
				customClass: 'aids',
				dangerouslyUseHTMLString: true,
				inputValue: row.number_in_class,
				inputPattern: /^[0-9]*$/,
				inputErrorMessage: '请输入数字',
				inputPlaceholder: '新的编号',
				cancelButtonText: '取消',
				confirmButtonText: '确定'
			}).then(async ({ value }) => {
				await this.$api.resource.updatedevices(row.id, {
					// device_sn: value,
					// number_in_class: row.number_in_class
					device_sn: row.device_sn,
					number_in_class: value
				})
				this.currentPage = 1
				this.getDevicesList()
				this.$message({
					type: 'success',
					message: '编辑成功!'
				})
			})
		},
		//班级
		checkoutClass(val) {
			this.params.d = val
		},
		//年级
		checkoutGrade(val) {
			this.params.c = val
			this.params.d = ''
			this.getClassNumber()
		},
		//每页下拉只显示的数据
		handleSizeChange(val) {
			this.currentPage = 1
			this.pageSize = val
			this.getDevicesList()
		},
		//当前点击的是第几页
		handleCurrentChange(currentPage) {
			this.currentPage = currentPage
			this.getDevicesList()
		},
		async getClassNumber() {
			const data = await this.$api.classgrade.classGrdeNumber({
				grade: this.params.c,
				school_id: this.schoolId || ''
			})
			this.classNumber = data
		}
	}
}
</script>
<style lang="scss" scoped>
.pagetotal {
	width: 200px;
	margin-left: 20px;
	font-size: 14px;
	line-height: 70px;
	font-family: PingFang SC-Medium, PingFang SC;
	font-weight: 500;
	color: #010101;
	text-overflow: ellipsis;
	white-space: nowrap;
	overflow: hidden;
}
::-webkit-scrollbar {
	width: 4px;
}

::-webkit-scrollbar-track {
	background-color: #f3f3f3;
}

::-webkit-scrollbar-thumb {
	background-color: #aaa;
}

::-webkit-scrollbar-thumb:hover {
	background-color: #aaa;
}

::-webkit-scrollbar-thumb:active {
	background-color: #aaa;
}
.el-form-item {
	margin-bottom: 1px;
}
.pagination {
	width: 100%;
	margin-top: 20px;
	text-align: right;
}
.pagination .el-pagination__total {
	float: left;
	font-size: 14px;
	font-family: PingFang SC-Medium, PingFang SC;
	font-weight: 500;
	color: #010101;
	-webkit-background-clip: text;
}
.pagination .el-pagination__jump {
	margin-left: 9px;
	font-weight: normal;
	color: #666666;
}
</style>
